<template>
	<i
		class="eia-icon"
		:class="classes">
	</i>
</template>

<script>
export default {
	name: 'eia-icon',
	props: {
		name: {
			type: String,
			required: true,
		},
		weight: {
			type: String,
			default: 'normal',
			validator( value ) {
				return value.match( /normal|solid/ );
			},
		},
		variation: {
			type: String,
			default: 'default',
			validator( value ) {
				return value.match( /default|primary|success|warning|danger/ );
			},
		},
	},

	computed: {
		classes() {
			return [
				`eia-icon--${this.variation}`,
				`eia-icon--${this.name}`,
				`eia-icon--${this.weight}`,
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-icon {
	width: 1em;
	height: 1em;
	display: inline-block;
	color: $color-main;

	&--primary {
		color: $color-primary;
	}

	&--success {
		color: $color-success;
	}

	&--warning {
		color: $color-warning;
	}

	&--danger {
		color: $color-danger;
	}
}
</style>
